export enum AmplitudeEventsEnum {
  COMERCIO_INICIO_SESION = "crm: comercio inicio sesion",
  SELECTED_MODULE = "Leal 360: usuario selecciona modulo del menu",
  SELECTED_HELP = "Leal 360: usuario selecciona ayuda",
  LEAL_360_USUARIO_SELECCIONA_PERFIL_DEL_MENU = "leal 360: usuario selecciona perfil del menu",
}

export enum DownloadsEventsEnum {
  COMERCIO_REALIZA_PETICION_DESCARGA = "leal360: presiono boton de descarga",
  COMERCIO_REALIZA_DESCARGA_CSV = "leal360: descargo un csv",
}
